import { sample } from 'effector';
import { createAddAccountModel } from 'features/add-account';
import { createBlockAccountModel } from 'features/block-account';
import { createDeleteAccountModel } from 'features/delete-account';
import { createEditAccountModel } from 'features/edit-account';
import { createUnblockAccountModel } from 'features/unblock-account';
import { createAccountRegistryModel } from 'entities/account';
import { accountPageModel } from './account-page-model';

const addAccountModel = createAddAccountModel();

const editAccountModel = createEditAccountModel();

const deleteAccountModel = createDeleteAccountModel();

const blockAccountModel = createBlockAccountModel();

const unblockAccountModel = createUnblockAccountModel();

const accountRegistryModel = createAccountRegistryModel({
	$accountId: accountPageModel.$accountId,
	onDelete: [deleteAccountModel.mutation.finished.success],
	onUpdate: [
		accountPageModel.accountIdSet,
		addAccountModel.addAccountMutation.finished.success,
		blockAccountModel.mutation.finished.success,
		unblockAccountModel.mutation.finished.success,
		editAccountModel.editAccountMutation.finished.success,
	],
});

sample({
	clock: addAccountModel.getAccountsQuery.finished.success,
	source: accountPageModel.$accountId,
	filter: Boolean,
	target: addAccountModel.form.fields.parentId.setValue,
});

export const accountPageAccountsModel = {
	accountRegistryModel,
	editAccountModel,
	deleteAccountModel,
	blockAccountModel,
	unblockAccountModel,
	addAccountModel,
};
